import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const activityNameSlice = createSlice({
  name: "activityName",
  initialState,
  reducers: {
    setActivityName(state, action) {
      state.activityName = action.payload;
    }
  }
});

const { actions, reducer } = activityNameSlice;

export const { setActivityName } = actions;

export const setActivityNameAction = data => async dispatch => {
  dispatch(setActivityName(data));
};

export default reducer;